/* Dansk katalog for locale-bank-misc-no.js (del 3 av 3).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'bank.guided.tabHandling': 'Til behandling · {{count}}',
  'bank.guided.tabDeviation': 'Skaber afvigelse · {{count}}',
  'bank.guided.postsCauseDeviation': '{{count}} bogførte poster skaber afvigelse',
  'bank.guided.linkHelp': 'Kobl kvittering eller faktura til købet. Hvis dokumentationen ikke findes, vælger du »Uden bilag«, så valget gemmes og kan kontrolleres senere.',
  'bank.guided.purchasesMissing': '{{count}} køb mangler bilag.',
  'bank.guided.noneMissing': 'Ingen bilag mangler.',
  'bank.guided.ctl.allHandled': 'Alle betalinger er behandlet',
  'bank.guided.ctl.remaining': '{{count}} tilbage',
  'bank.guided.ctl.vouchersLinked': 'Nødvendige bilag er koblet',
  'bank.guided.ctl.missingVouchers': '{{count}} mangler bilag',
  'bank.guided.ctl.statementBalances': 'Kontoudtogets saldi stemmer',
  'bank.guided.ctl.deviation': 'Afvigelse {{amount}}',
  'bank.guided.ctl.ledgerBalance': 'Bogført banksaldo stemmer',
  'bank.guided.ctl.clear': 'Klar',
  'bank.guided.finishNote': 'Når du afslutter, kontrollerer Plumme saldiene, låser perioden og flytter kontoudtoget til arkivet.',
  'bank.guided.allChecked': 'Alt er kontrolleret og klar.',
  'bank.guided.resolveToFinish': 'Løs punkterne ovenfor for at låse op for afslutning.',
  'bank.guided.toast.noPending': 'Ingen forslag venter på godkendelse.',
  'bank.guided.superLinks': 'SuperPlumma kobler',
  'bank.guided.approveSuggestions': 'Godkend forslagene',
  'bank.guided.note.tapPurchase': 'Tryk på et bilag og derefter på det køb, du vil koble det til.',
  'bank.guided.note.tapSuggestion': 'Tryk på et bilag og derefter på forslaget. Mulige match markeres i listen.',
  'bank.guided.note.dragPurchase': 'Træk et bilag over på det køb, du vil koble det til.',
  'bank.guided.note.dragSuggestion': 'Træk et bilag over på et forslag. Mulige match markeres i listen.',
  'bank.guided.err.checkImportFirst': 'Kontrollér importovergangen først.',
  'bank.guided.toast.postingVoided': 'Posteringen er annulleret',
  'bank.guided.archiving': 'Arkiverer…',
  'bank.guided.archiveNote': 'Kontrollen låses og flyttes til arkivet. Banklinjerne blev allerede bogført, da de blev godkendt.',
  'bank.archive.lockedNote': 'Afstemningen er låst. Udvid en linje for at se bilag og bogføring. Konto, moms og intern beskrivelse kan korrigeres uden at ændre bankbeløbet.',
  'bank.archive.searchPh': 'Søg i posteringer',
  'bank.archive.searchHelp': 'Søg på dato, beskrivelse, beløb, konto eller bilag.',
  'bank.archive.countOf': '{{shown}} af {{total}} posteringer',
  'bank.archive.handled': 'Behandlet',
  'bank.archive.code': 'Kode {{code}}',
  'bank.archive.auditTrail': 'Revisionsspor',
  'bank.archive.correctionsOne': '{{count}} korrektion',
  'bank.archive.correctionsMany': '{{count}} korrektioner',
  'bank.archive.noCorrections': 'Ingen korrektioner',
  'bank.archive.internalDescription': 'Intern beskrivelse',
  'bank.archive.noVoucher': 'Intet bilag koblet',
  'bank.archive.noMatch': 'Ingen posteringer matcher søgningen eller filtrene.',
  'bank.archive.err.correctFailed': 'Kunne ikke korrigere posteringen.',
  'bank.importFix.err.openFirst': 'Åbn koblingen eller posteringen, før aflæsningen korrigeres.',
  'bank.importFix.err.reasonLine': 'Skriv kort, hvorfor banklinjen korrigeres.',
  'bank.importFix.err.amountNumber': 'Beløbet skal være et tal.',
  'bank.importFix.removeFromRecon': 'Ignorér linje',
  'bank.importFix.warnTitle': 'Brug kun, hvis PDF/CSV er aflæst forkert.',
  'bank.importFix.warnBody': 'Dette ændrer ikke banken eller bogførte bilag. De oprindelige værdier bevares i historikken.',
  'bank.importFix.blocked': 'Linjen er allerede koblet eller bogført. Åbn koblingen/posteringen, før selve aflæsningen korrigeres.',
  'bank.importFix.originalRead': 'Oprindeligt aflæst',
  'bank.importFix.effect': 'Effekt på afstemningen',
  'bank.importFix.deviationNow': 'Afvigelse nu:',
  'bank.importFix.afterCorrection': 'Efter korrektion:',
  'bank.importFix.stillDeviates': 'Hvis afvigelsen stadig består, så kontrollér, om primo/ultimo også er aflæst forkert.',
  'bank.importFix.fixLine': 'Ret linjen',
  'bank.importFix.removeMisread': 'Ignorér linje',
  'bank.ignoreLine': 'Ignorér linje',
  'bank.ignoreLineHelp': 'Brug kun dette, når linjen er fejlaflæst og ikke findes i kontoudtoget. Linjen bevares i historikken.',
  'bank.ignoreLineConfirm': 'Ignorér linjen',
  'bank.ignoreLineReason': 'Hvorfor ignoreres linjen?',
  'bank.ignoreLineReasonHint': 'Kræves til revisionssporet.',
  'bank.ignoreLineReasonPlaceholder': 'F.eks. linjen findes ikke i kontoudtoget',
  'bank.importFix.removeNote': 'Linjen bliver liggende i historikken, men tæller som 0,00 kr og regnes som færdig i afstemningen. Bruges kun, når linjen ikke findes i kontoudtoget.',
  'bank.importFix.whyReading': 'Hvorfor korrigeres aflæsningen?',
  'bank.importFix.whyReadingPh': 'F.eks. OCR aflæste forkert beløb / linjen findes ikke i kontoudtoget',
  'bank.importFix.err.balancesNumber': 'Primo og ultimo skal være tal.',
  'bank.importFix.err.reasonBalance': 'Skriv kort, hvorfor saldoen korrigeres.',
  'bank.importFix.saveBalance': 'Gem saldo',
  'bank.importFix.balanceWarnTitle': 'Ændr kun, hvis saldoen fra kontoudtoget/importen er forkert.',
  'bank.importFix.balanceWarnBody': 'Primo hentes normalt fra forrige afstemte ultimo. Den oprindeligt aflæste saldo bevares.',
  'bank.importFix.resultPrefix': 'Med de aktuelle behandlede banklinjer bliver saldoafvigelsen',
  'bank.importFix.whyBalance': 'Hvorfor korrigeres saldoen?',
  'bank.importFix.whyBalancePh': 'F.eks. ultimo blev aflæst fra en forkert række i PDF\'en',
  'bank.loan.intro': 'Brug dette til låneoptagelse, afdrag eller betalinger, der kan opdeles i afdrag, renter og gebyr. Den valgte konto hentes fra virksomhedens aktive kontoplan, og posteringen sker uden moms.',
  'bank.loan.account': 'Låne-/gældskonto',
  'bank.loan.noAccount': 'Fandt ingen almindelig låne-/gældskonto i den aktive kontoplan. Opret den rigtige konto, eller brug fri postering.',
  'bank.loan.principal': 'Afdrag / lånebeløb',
  'bank.loan.splitMismatch': 'Opdelingen skal stemme med bankbeløbet. Tilbage: {{amount}} kr.',
  'bank.loan.docLinked': 'Dokumentation er koblet.',
  'bank.loan.docRemember': 'Husk dokumentationen.',
  'bank.loan.docHelp': 'Upload låneaftale, afdragsplan eller andet grundlag. Opdelingen skal kunne dokumenteres.',
  'bank.loan.complex': 'Vedrører linjen nærtstående, en usædvanlig konto eller et mere kompliceret låneforhold?',
  'bank.loan.useFree': 'Brug fri postering',
  'bank.group.err.sameDirection': 'Alle banklinjer i en fordelingsgruppe skal have samme retning.',
  'bank.group.err.pickBoth': 'Vælg begge banklinjer i overførslen.',
  'bank.group.toast.transferApproved': 'Overførslen er godkendt og bogført samlet.',
  'bank.group.toast.allocationApproved': 'Fordelingen er godkendt og bogført samlet.',
  'bank.group.err.approveFailed': 'Matchgruppen kunne ikke godkendes.',
  'bank.group.title': 'Match flere bankposteringer',
  'bank.group.approve': 'Godkend og bogfør gruppe',
  'bank.group.oneOperation': 'Én kontrolleret handling',
  'bank.group.oneOperationHelp': 'Gruppen reserverer alle valgte banklinjer. Bogføring og kobling sker samlet i backend, når du godkender.',
  'bank.group.matchType': 'Type match',
  'bank.group.typeAllocation': 'Fordel betaling på åbne poster',
  'bank.group.typeTransfer': 'Intern overførsel mellem egne konti',
  'bank.group.sourceLine': 'Linje fra én konto',
  'bank.group.counterLine': 'Modpost på egen konto',
  'bank.group.pickOpposite': 'Vælg modsat banklinje',
  'bank.group.transferRules': 'Kun samme dato og beløb, modsat fortegn og en anden konfigureret bankkonto tilbydes. Forskellige datoer kræver en transitkonto.',
  'bank.group.noOpenItems': 'Ingen åbne {{kind}} kan allokeres.',
  'bank.group.customerInvoices': 'kundefakturaer',
  'bank.group.supplierInvoices': 'leverandørfakturaer',
  'bank.group.itemRest': '{{number}} · {{party}} · rest {{amount}}',
  'bank.group.removeRow': 'Fjern række',
  'bank.corr.err.reasonVoid': 'Skriv kort, hvorfor posteringen annulleres.',
  'bank.corr.err.notFieldCorrectable': 'Denne posttype kan ikke feltrettes fra bankafstemningen. Annuller posteringen, og bogfør den korrekt på ny, eller åbn bilaget i bilagsjournalen.',
  'bank.corr.err.supplierPaymentVoid': 'Betalinger af leverandørfakturaer annulleres fra leverandørbilaget.',
  'bank.corr.err.noSupportedAction': 'Der blev ikke fundet en understøttet handling for denne bogførte post.',
  'bank.receipt.toast.trashed': 'Bilaget er flyttet til papirkurven.',
  'bank.receipt.err.deleteFailed': 'Bilaget kunne ikke slettes.',
  'bank.receipt.deleting': 'Sletter…',
  'bank.receipt.delete': 'Slet bilag',
  'bank.mode.toFull': 'Skift til fuldt overblik',
  'bank.mode.toGuided': 'Skift til trin for trin',
  'bank.import.toast.privateSaved': 'Privat kontoudtog gemt - klar til gennemgang',
  'bank.import.toast.saved': 'Bankudskrift gemt - klar til afstemning',
  'bank.inbox.view.statement': 'Denne udskrift',
  'bank.inbox.view.unlinked': 'Kun ikke koblede',
  'bank.inbox.view.all': 'Alle bilag',
  'bank.inbox.showInList': 'Vis i indbakken',
  'bank.inbox.viewing': 'Viser: {{view}} · {{hidden}} skjult',
  'bank.inbox.waiting': '{{count}} bilag venter på behandling',
  'bank.inbox.hide': 'Skjul indbakke',
  'bank.inbox.companyAddress': 'virksomhedens bilagsindbakke',
  'bank.inbox.defaultNote': 'Træk et bilag over på en banklinje, eller lad SuperPlumma foreslå match.',
  'bank.inbox.uploadVoucher': 'Upload bilag',
  'bank.inbox.orDrag': 'Eller træk · slip på en linje, der mangler bilag',
  'bank.inbox.dropHint': 'Slip filer her for at uploade nye bilag.',
  'bank.inbox.noMatch': 'Ingen bilag matcher søgningen.',
  'bank.inbox.noneInSelection': 'Ingen bilag i dette udvalg · {{hidden}} skjult af filteret',
  'bank.inbox.allDone': 'Alle bilag er færdigbehandlet',
  'bank.inbox.empty': 'Indbakken er tom',
  'bank.inbox.tip.showAll': 'Tryk for at vise alle banklinjer igen',
  'bank.inbox.tip.showLine': 'Tryk for at vise den banklinje, bilaget er koblet til',
  'bank.inbox.tip.linkedElsewhere': 'Koblet uden for denne bankudskrift',
  'bank.inbox.linkedHere': 'Koblet · {{label}}',
  'bank.inbox.linkedIn': 'Koblet i {{label}}',
  'bank.inbox.previewName': 'Forhåndsvis {{name}}',
  'bank.inbox.voucherLower': 'bilag',
  'bank.inbox.filteredOne': 'Filtreret på ét bilag',
  'bank.inbox.filteredN': 'Filtreret på {{count}} bilag',
  'bank.inbox.filterShowsLinked': 'Viser kun de banklinjer, bilagene er koblet til',
  'bank.inbox.showAllLines': 'Vis alle linjer',
  'bank.inbox.nBankLines': '{{count}} banklinjer',
  'bank.inbox.bankLineLower': 'banklinje',
  'bank.inbox.anotherStatement': 'en anden bankudskrift',
  'bank.inbox.toast.linkedElsewhere': 'Bilaget er koblet til en banklinje i {{label}}.',
  'bank.resolve.annulText': 'Posten er dobbeltbogført. Tilbagefør den, så den ikke tæller med. Et eventuelt bilag lægges automatisk tilbage i indbakken.',
  'bank.resolve.correctText': 'Bogføringen skal blive stående, men konto, moms eller intern beskrivelse er forkert. Bankbeløb og dato forbliver låst.',
  'bank.resolve.err.voidFailed': 'Den bogførte post kunne ikke annulleres.',
  'bank.resolve.voiding': 'Annullerer…',
  'bank.resolve.confirmVoid': 'Bekræft annullering',
  'bank.resolve.voidReason': 'Årsag til annullering',
  'bank.resolve.voidReasonHint': 'Påkrævet. Begrundelsen gemmes i revisionssporet.',
  'bank.resolve.voidReasonPh': 'Beskriv kort, hvorfor posteringen skal annulleres',
  'bank.resolve.row.postedEntry': 'Bogført post',
  'bank.resolve.row.account': 'Konto',
  'bank.resolve.row.vat': 'Moms',
  'bank.resolve.row.amount': 'Beløb',
  'bank.resolve.row.lineDate': 'Dato på banklinjen',
  'bank.resolve.row.bankLine': 'Banklinje',
  'bank.resolve.row.voucher': 'Bilag',
  'bank.resolve.row.notLinked': 'Ikke koblet',
  'bank.resolve.reopenAsDeviation': 'Åbn som afvigelse',
  'bank.resolve.releaseInvestmentMatch': 'Frigiv bankkobling',
  'bank.resolve.reverse': 'Tilbagefør',
  'bank.resolve.alreadyPosted': 'Denne banklinje er allerede bogført eller matchet. Den kan derfor ikke behandles som en ny linje.',
  'bank.resolve.useCorrection': 'Brug rettelse til konto, moms eller intern beskrivelse. Bankbeløb, dato og kobling forbliver låst.',
  'bank.resolve.reverseInfo': 'Tilbageførsel annullerer købet med sporbarhed og åbner banklinjen for ny kontrol.',
  'bank.resolve.existingInfo': 'Dette er koblet til et eksisterende bilag eller en eksisterende post. Ret selve bilaget, hvis grundlaget er forkert.',
  'bank.resolve.verifiableInfo': 'Denne kobling kan efterprøves fra postdetaljerne.',
  'bank.resolve.approving': 'Godkender…',
  'bank.resolve.approveN': 'Godkend {{count}} forslag',
  'bank.resolve.confirmIntro': 'Kontrollér opsummeringen. Forslag, der er matchet mod en eksisterende post, opretter ikke ny bogføring.',
  'bank.resolve.voucherReturns': 'Bilaget »{{name}}« lægges automatisk tilbage i indbakken, når posten annulleres.',
  'bank.err.uploadVoucherFailed': 'Bilaget kunne ikke uploades.',
  'bank.drop.attachAsDoc': 'Vedhæftes som dokumentation',
  'bank.drop.uploadAnalyzeLink': 'Uploades, analyseres og kobles',
  'bank.receipt.confirmDelete': 'Slet bilaget fra indbakken? Det flyttes til papirkurven og kan gendannes.',
  'bank.percentDone': '{{pct}}% fuldført',
  'mypage.role.owner': 'Ejer',
  'mypage.role.admin': 'Administrator',
  'mypage.role.accountant': 'Bogholder',
  'mypage.role.viewer': 'Læser',
  'mypage.shortcut.oversikt.title': 'Overblik',
  'mypage.shortcut.oversikt.text': 'Sundhedsscore og økonomisk overblik for husstanden',
  'mypage.shortcut.forbruk.title': 'Forbrug',
  'mypage.shortcut.forbruk.text': 'Hvad pengene går til, fordelt på kategorier',
  'mypage.shortcut.familie.title': 'Familie',
  'mypage.shortcut.familie.text': 'Fælles budget og fordeling i husstanden',
  'mypage.shortcut.fremtid.title': 'Fremtid',
  'mypage.shortcut.fremtid.text': 'Opsparing, lån, pension og fremtidsplaner',
  'mypage.shortcut.skatt.title': 'Skat',
  'mypage.shortcut.skatt.text': 'Privat skattemelding, fradrag og estimat',
  'mypage.fallback.business': 'Virksomhed',
  'mypage.fallback.signedInUser': 'Logget ind bruger',
  'mypage.fallback.employerLoadError': 'Arbejdsgivere kunne ikke hentes.',
  'mypage.verify.body': 'Nogle funktioner, blandt andet klientinvitationer og medarbejderportalen, kræver, at {{email}} er bekræftet. Send linket igen, hvis du ikke kan finde det, åbn linket i e-mailen, og tryk derefter på, at du har bekræftet.',
  'mypage.verify.resend': 'Send bekræftelse igen',
  'mypage.verify.sending': 'Sender...',
  'mypage.verify.confirmed': 'Jeg har bekræftet',
  'mypage.verify.checking': 'Kontrollerer...',
  'mypage.err.profileNotConnected': 'Lagring af profil er ikke koblet til backend.',
  'mypage.toast.profileUpdated': 'Profilen er opdateret',
  'mypage.err.profileUpdateFailed': 'Profilen kunne ikke opdateres.',
  'mypage.err.verifyNotConnected': 'E-mailbekræftelse er ikke koblet til backend.',
  'mypage.toast.alreadyVerified': 'E-mailadressen er allerede bekræftet.',
  'mypage.toast.verifyResent': 'Bekræftelseslinket er sendt igen.',
  'mypage.err.verifySendFailed': 'Bekræftelseslinket kunne ikke sendes.',
  'mypage.err.verifyStatusFailed': 'E-mailstatus kunne ikke kontrolleres.',
  'mypage.toast.emailVerified': 'E-mailadressen er bekræftet.',
  'mypage.toast.stillUnverified': 'Adressen er stadig ikke bekræftet. Tjek indbakken, og prøv igen.',
  'mypage.err.personalNotConnected': 'Privatøkonomi er ikke koblet til backend i denne version.',
  'mypage.toast.personalCreated': 'Privatøkonomi er oprettet',
  'mypage.err.personalCreateFailed': 'Privatøkonomi kunne ikke oprettes.',
  'mypage.toast.openPersonalForFamily': 'Åbn Privatøkonomi for at ændre Familie.',
  'mypage.toast.familyEnabled': 'Familie er aktiveret.',
  'mypage.toast.familyDisabled': 'Familie er deaktiveret.',
  'mypage.err.familySaveFailed': 'Indstillingen for Familie kunne ikke gemmes.',
  'mypage.titleHelp': 'Min side er din personlige konto i Plumme — adskilt fra selve regnskaberne. Her ser du din profil, de virksomheder, du har adgang til, de arbejdsgivere, du er ansat hos, og indgangen til din privatøkonomi.',
  'mypage.field.memberSince': 'Medlem siden',
  'mypage.toast.onboardingNotLoaded': 'Onboarding er ikke indlæst endnu.',
  'mypage.orgNumber': 'Org. {{orgnr}}',
  'mypage.biz.loadingTitle': 'Henter virksomheder',
  'mypage.biz.loadingText': 'Forbinder til Plumme backend.',
  'mypage.biz.emptyTitle': 'Ingen egne virksomheder',
  'mypage.biz.emptyText': 'Du kan oprette en virksomhed her senere, også selvom du kun bruger Plumme som bogholder eller privatbruger.',
  'mypage.clients.title': 'Klientopgaver',
  'mypage.clients.help': 'Virksomheder, hvor du er inviteret som bogholder, administrator eller læser. Klientdata holdes adskilt fra egne virksomheder og Privatøkonomi.',
  'mypage.clients.setup': 'Opsætning for bogholder',
  'mypage.clients.access': 'Klientadgang',
  'mypage.clients.empty': 'Du har ingen aktive klientopgaver. Invitationer vises globalt efter login.',
  'mypage.pf.creating': 'Opretter...',
  'mypage.pf.create': 'Opret privatøkonomi',
  'mypage.pf.intro': 'Din personlige rådgiver for husstandens økonomi - holdt adskilt fra virksomhedernes regnskab. Vælg et overblik for at komme i gang.',
  'mypage.pf.family': 'Familie',
  'mypage.pf.familyText': 'Vis siden Familie i Privatøkonomi.',
  'mypage.pf.emptyIntro': 'Opret en privatøkonomi-klient for at samle privat overblik, import, husstand, skat og rapporter uden at blande det med regnskabsklienterne.',
  'mypage.emp.fallbackRole': 'Medarbejder',
  'mypage.emp.loadingTitle': 'Henter arbejdsgivere',
  'mypage.emp.emptyTitle': 'Ingen arbejdsgivere',
  'mypage.emp.loadingText': 'Forbinder til medarbejderportalen.',
  'mypage.emp.emptyText': 'Der er ikke registreret adgang til medarbejderportalen for brugeren.',
  'mypage.err.passwordResetNotConnected': 'Nulstilling af adgangskode er ikke koblet til backend.',
  'mypage.toast.passwordLinkSent': 'Et link til at ændre adgangskode er sendt på e-mail',
  'mypage.err.passwordLinkFailed': 'Linket til adgangskode kunne ikke sendes.',
  'mypage.saving': 'Gemmer...',
  'mypage.hh.loadError': 'Husstandskoblingen kunne ikke hentes.',
  'mypage.hh.updateError': 'Husstanden kunne ikke opdateres.',
  'mypage.hh.inviteEmailFailed': 'Invitationen er oprettet, men e-mailen kunne ikke sendes. Du kan prøve igen.',
  'mypage.hh.inviteSent': 'Invitationen er oprettet og sendt.',
  'mypage.hh.left': 'Husstandskoblingen er afsluttet.',
  'mypage.hh.hiddenPending': 'Invitationen er trukket tilbage og fjernet fra listen.',
  'mypage.hh.hidden': 'Invitationen er fjernet fra listen.',
  'mypage.hh.loading': 'Henter husstandsstatus …',
  'mypage.hh.partnerFallback': 'Tilknyttet partner',
  'mypage.hh.twoAccounts': 'To separate konti · delt Familie-side',
  'mypage.hh.leaveConfirm': 'Frakobl husstanden? I beholder begge jeres egne data, mens den delte Familie-profil afsluttes.',
  'mypage.hh.leaving': 'Frakobler …',
  'mypage.hh.leave': 'Frakobl husstanden',
  'mypage.hh.inviteIntro': 'Invitér en partner via e-mail. Modtageren kan logge ind eller oprette en ny Plumme-konto og får hjælp til at oprette Privatøkonomi, før koblingen godkendes.',
  'mypage.hh.inviting': 'Opretter …',
  'mypage.hh.invite': 'Invitér partner',
  'mypage.hh.userFallback': 'Plumme-bruger',
  'mypage.hh.joined': 'Husstanden er koblet sammen.',
  'mypage.hh.sentInvites': 'Sendte invitationer',
  'mypage.hh.resendFailedToast': 'Invitationen er aktiv, men e-mailen kunne ikke sendes.',
  'mypage.hh.resentToast': 'Invitationen er sendt igen.',
  'mypage.hh.resend': 'Send igen',
  'mypage.hh.remind': 'Påmind',
  'mypage.hh.withdrawn': 'Invitationen er trukket tilbage.',
  'mypage.hh.removeFromList': 'Fjern fra listen',
  'mypage.hh.status.pending': 'Venter på svar · {{delivery}}',
  'mypage.hh.status.expired': 'Udløbet',
  'mypage.hh.status.declined': 'Afvist',
  'mypage.hh.status.canceled': 'Trukket tilbage',
  'mypage.hh.status.accepted': 'Accepteret',
  'mypage.hh.delivery.delivered': 'e-mail leveret',
  'mypage.hh.delivery.opened': 'e-mail åbnet',
  'mypage.hh.delivery.clicked': 'link åbnet',
  'mypage.hh.delivery.failed': 'e-mail mislykkedes',
  'mypage.hh.delivery.bounced': 'e-mail afvist',
  'mypage.hh.delivery.complained': 'markeret som spam',
  'mypage.hh.delivery.delivery_delayed': 'e-mail forsinket',
  'mypage.hh.delivery.sent': 'e-mail sendt',
  'audit.domain.settings': 'Indstillinger',
  'audit.domain.invoices': 'Faktura',
  'audit.domain.sales': 'Salg',
  'audit.domain.expenses': 'Køb',
  'audit.domain.customers': 'Kunder',
  'audit.domain.products': 'Produkter',
  'audit.domain.suppliers': 'Leverandører',
  'audit.domain.inbox': 'Indbakke',
  'audit.domain.bank': 'Bank',
  'audit.domain.mileage': 'Kørebog',
  'audit.domain.payroll': 'Løn',
  'audit.domain.business': 'Virksomhed',
  'audit.domain.access': 'Adgange',
  'audit.summary.rows': '{{count}} rækker',
  'audit.summary.fields': '{{count}} felter',
  'audit.event.updated': 'Opdaterede {{domains}}',
  'audit.event.updatedBusinessData': 'Opdaterede virksomhedens data',
  'audit.event.businessCreated': 'Oprettede virksomheden',
  'audit.event.inviteCreated': 'Inviterede {{email}} som {{role}}',
  'audit.event.inviteAccepted': '{{user}} accepterede invitationen',
  'audit.event.deletionRequestedFor': 'Anmodede om sletning af virksomheden {{date}}',
  'audit.event.deletionRequested': 'Anmodede om sletning af virksomheden',
  'audit.event.deletionCanceled': 'Annullerede sletning af virksomheden',
  'audit.fallback.newUser': 'ny bruger',
  'audit.fallback.userLower': 'bruger',
  'audit.fallback.user': 'Bruger',
  'audit.fallback.unknownUser': 'Ukendt bruger',
  'audit.err.loadFailed': 'Aktivitetsloggen kunne ikke hentes.',
  'audit.meta.time': 'Tidspunkt',
  'audit.meta.user': 'Bruger',
  'audit.meta.role': 'Rolle',
  'audit.meta.action': 'Handling',
  'audit.meta.source': 'Kilde',
  'audit.meta.invite': 'Invitation',
  'audit.meta.targetUser': 'Målbruger',
  'audit.detail.before': 'Før:',
  'audit.detail.after': 'Efter:',
  'audit.titleHelp': 'Aktivitetsloggen er en revisionslog: den viser alle vigtige handlinger, der er udført i regnskabet - hvem der gjorde hvad, hvornår og inden for hvilket område. Nyttig for sporbarhed og kontrol, når flere samarbejder.',
  'audit.search': 'Søg i aktivitetsloggen for {{year}}',
  'audit.scope.all': 'Alle',
  'audit.scope.others': 'Andre',
  'audit.scope.mine': 'Mig',
  'audit.scope.access': 'Adgange',
  'audit.col.event': 'Hændelse',
  'audit.empty.loadingTitle': 'Henter aktivitetslog',
  'audit.empty.loadingText': 'Forbinder til Plumme backend.',
  'audit.empty.noMatchTitle': 'Ingen resultater',
  'audit.empty.noMatchText': 'Ingen aktiviteter passer til filteret. Prøv at nulstille det.',
});
